<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog__large">
        <v-card class="modal-charts" v-if="!loading">
            <v-flex xs12 row justify-center line-buttons ma-0 v-if="device">
                <div class="bold-text text-center d-inline-flex">
                    {{device.name}}
                    <span v-if="device.location" class="main-text d-inline-flex text-lowercase">, {{device.location}}</span>
                </div>
            </v-flex>
            <v-layout w-100 column>
                <v-flex xs12 d-inline-flex justify-center align-center my-2>
                    <v-btn class="btn-light-grey mr-3" :class="{'btn-light-grey__active': week}" @click="week = true">
                        Неделя
                    </v-btn>
                    <div class="d-inline-flex mx-5" v-if="!week">
                        <div @click="increaseDay" class="date-arrow left arrow-btn-black" :class="{'date-arrow__disabled': day == daysUniq.length - 1}">
                            <ArrowRightIcon/>
                        </div>
                        <div>{{daysUniq[day] | formatDate }}</div>
                        <div @click="reduceDay" class="date-arrow right arrow-btn-black" :class="{'date-arrow__disabled': day == 0}">
                            <ArrowRightIcon/>
                        </div>
                    </div>
                    <v-btn class="btn-light-grey ml-3" :class="{'btn-light-grey__active': !week}" @click="week = false">
                        День
                    </v-btn>
                </v-flex>
            </v-layout>
            <v-layout ma-0 justify-center column>
                <v-flex xs12 d-inline-flex mx-2 mb-5 class="chart-column" v-if="illuminances && illuminances.length">
                    <div class="common-text text-center mt-2">
                        Освещённость, лк
                    </div>
                    <div class="wrapper">
                        <VueApexCharts width="100%" type="area" :options="chartIlluminanceOptions" :series="illuminances"></VueApexCharts>
                    </div>
                </v-flex>
            </v-layout>
            <v-flex class="modal-row d-flex justify-end mt-8">
                <v-btn class="btn-grey main-text" @click="close">
                    Отмена
                </v-btn>
            </v-flex>
        </v-card>
        <v-card v-else min-height="150px" min-width="250px" class="d-flex align-center justify-center">
            <div>
                <div class="common-text mb-2">
                    Зарузка данных...
                </div>
                <v-layout row align-center justify-center>
                    <v-flex class="d-inline-flex" style="max-width: 42px">
                        <v-img class="connection-animate" height="42px" width="42px" :src="require('@/assets/icons/connection.png')"></v-img>
                    </v-flex>
            </v-layout>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ArrowRightIcon from "@/assets/icons/ArrowRightIcon";

export default {
    name: "ModalLightingCharts",
    components: {ArrowRightIcon, VueApexCharts},
    props: {
        deviceUID: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            actions: [],
            week: false,
            day: null,
            daysUniq: [],
            device: null,
            dialog: false,
            loading: false,
            chartIlluminanceOptions: {
                chart: {
                    events: {
                        click: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                        mouseMove: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                    },
                    height: 350,
                    toolbar: {
                        show: false,
                    },
                    type: "area",
                    zoom: {
                        enabled: false,
                    },
                },
                colors: ["#FFBAB8"],
                dataLabels: {
                    enabled: false,
                },
                fill: {
                    type: "gradient",
                    colors: ['#FFBAB8', '#fecdcb', '#fff7d0', '#FFFFFF'],
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.7,
                        opacityTo: 0.9,
                        stops: [0, 90, 100]
                    }
                },
                plotOptions: {
                    area: {
                        fillTo: "end",
                    }
                },
                tooltip: {
                    enabled: true,
                    x: {
                        show: false,
                    },
                    y: {
                        formatter: (val, { seriesIndex, dataPointIndex, w }) => {
                            let time = w.config.series[seriesIndex].data[dataPointIndex].x.split(" ");
                            if (this.week) {
                                const [year, month, day] = time[0].split("-");
                                time = day + "." + month + " в " + time[1].slice(0, 5);
                            } else {
                                time = "в " + time[1].slice(0, 5);
                            }
                            return val ? val.toFixed(0) + " лк " + time : "";
                        },
                        title: {
                            show: false,
                        },
                    },
                    marker: {
                        show: false,
                    },
                },
                xaxis: {
                    type: "category",
                    labels: {
                        formatter: (val) => {
                            return this.getLabel(val);
                        }
                    },
                    tickAmount: 9,
                    tickPlacement: "on",
                    tooltip: {
                        enabled: false
                    },
                    forceNiceScale: true,
                },
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            return val.toFixed(0) + " лк";
                        },
                    },
                },
            },
        };
    },
    filters: {
        formatDate(val) {
            if (!val) {
                return null;
            }
            let [year, month, day] = val.split("-");
            return day + "." + month + "." + year;
        },
    },
    computed: {
        illuminances() {
            if (this.actions && this.actions.length > 0) {
                let data = this.actions;
                let temp = [];
                if (!this.week) {
                    data = JSON.parse(JSON.stringify(this.actions)).filter((el) => {
                        return el.date.split(" ")[0] == this.daysUniq[this.day]
                    });
                    data.forEach((el) => {
                        let obj = {y: el.state.illuminance};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                    if (this.day == 0) {
                        let i = this.getLabel(temp[0].x);
                        for (i = parseInt(i) + 1; i < 24; i++) {
                            let hour = String(i).padStart(2, "0");
                            let exist = temp.find((el) => (el.x).split(" ")[1].slice(0, 2) === hour );
                            if (exist === undefined) {
                                temp.unshift({
                                    y: null,
                                    x: ` ${hour}:00`
                                });
                            }
                        }
                    }
                }
                else {
                    data.forEach((el) => {
                        let obj = {y: el.state.illuminance};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                }
                temp.reverse();
                return [ { name: "Освещённость", data: temp } ];
            }
            return [ { name: "Освещённость", data: [] } ];
        },
    },
    methods: {
        open() {
            this.dialog = true;
            this.loadPage();
        },
        close() {
            this.dialog = false;
        },
        loadPage() {
            if (this.deviceUID) {
                this.getData();
            }
        },
        getData() {
            this.loading = true;
            this.$http.get('/devices/hotel-admin/lighting-history/' + this.deviceUID + '/')
                .then((res) => {
                    this.actions = res.data.actions;
                    this.device = res.data.device;
                    this.actions.forEach((el) => {
                        let date = el.date.split(" ")[0];
                        if (!this.daysUniq.includes(date)) {
                            this.daysUniq.push(date);
                        }
                    });
                    this.day = 0;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        reduceDay() {
            if (this.day > 0) {
                this.day--;
            }
        },
        increaseDay() {
            if (this.day < this.daysUniq.length - 1) {
                this.day++;
            }
        },
        getLabel(val) {
            if (val) {
                if (!this.week) {
                    return String(parseInt((val).split(" ")[1].slice(0, 5).split(":")[0])).padStart(2, "0");
                }
                let dateLabel = val.split(" ")[0].split("-");
                return dateLabel[2] + "." + dateLabel[1];
            }
            return "";
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-charts {
    position: relative;
    padding: 24px;
    width: 700px;
}
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-light-grey {
    display: flex;
    padding: 12px 24px;
    background: rgba(247, 247, 249, 0.38);
    box-shadow: 0 4px 15px rgba(37, 37, 37, 0.1);
    border-radius: 30px;
    justify-content: space-between;
    max-height: 72px;
    width: 90px !important;
    align-items: center;

    &__active {
        background: linear-gradient(180deg, rgba(255, 244, 188, 0.8) 0%, rgba(255, 132, 132, 0.432) 100%);
    }
}

.date-arrow {
    float: left;
    width: 28px;
    height: 28px;
    line-height: 32px;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &.left {
        transform: rotate(180deg);
        padding-left: 15px;
    }

    &.right {
        padding-left: 15px;
    }

    svg {
        stroke: #130F26;
    }

    &__disabled {
        svg {
            stroke: rgba(0,0,0,.3);
        }
    }
}

.wrapper {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    min-height: 250px;
    max-height: 300px;
}

.line-buttons {
    min-height: 36px;
    max-height: 36px;
    height: 36px;
}

.chart-column {
    flex-direction: column;
    justify-content: center;
}


.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}
</style>